import { Controller } from "@hotwired/stimulus"

// Lightweight controller dedicated to closing the modal. The bigger
// manager_approval controller lives on the trigger button and handles
// the open + verify flow. Cancel is decoupled so any element inside
// the modal can dispatch a close.
export default class extends Controller {
  cancel(event) {
    event?.preventDefault()
    this.element.classList.add("hidden")
    this.element.classList.remove("flex")
    // Reset the inner pin-keypad back to tile-selection so reopening
    // doesn't show a half-filled PIN panel.
    const tiles = this.element.querySelector('[data-pin-keypad-target="tiles"]')
    const panel = this.element.querySelector('[data-pin-keypad-target="panel"]')
    const display = this.element.querySelector('[data-pin-keypad-target="display"]')
    if (tiles) tiles.hidden = false
    if (panel) panel.hidden = true
    if (display) display.textContent = ""
  }
}
